import { render, staticRenderFns } from "./RoleSettingsForm.vue?vue&type=template&id=5e933112&"
import script from "./RoleSettingsForm.vue?vue&type=script&lang=js&"
export * from "./RoleSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./RoleSettingsForm.vue?vue&type=style&index=0&id=5e933112&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports